export const MIN_LOADING_DURATION_MS = 1000;

// Keeps a loading indicator visible for at least `minDurationMs` so fast API
// responses don't cause the button label to flicker between text and dots.
export const withMinDuration = async (
  promise,
  minDurationMs = MIN_LOADING_DURATION_MS
) => {
  const startedAt = Date.now();
  try {
    return await promise;
  } finally {
    const elapsed = Date.now() - startedAt;
    if (elapsed < minDurationMs) {
      await new Promise((resolve) =>
        setTimeout(resolve, minDurationMs - elapsed)
      );
    }
  }
};
